import * as Types from '@/types';

import { gql } from '@apollo/client';
export const SalesPortalOrderEntryTable_OrderEntryItemFieldsFragmentDoc = gql`
  fragment SalesPortalOrderEntryTable_OrderEntryItemFields on OrderEntryItem {
    item_info {
      brand
      description
      image_url
      name
      pack_size
    }
    order_guide_collection_ids
    order_info {
      added_at
      cart_quantity
      order_item_id
      order_id
    }
    price_edit_display_info {
      key
      currency
      trend
      value
      value_display
    }
    labels {
      lead_time_label {
        display_text {
          en
          es
          fr
          zh
        }
        level
      }
      availability_label {
        i18n_key
        level
      }
      essential_item_label {
        i18n_key
        level
      }
      order_guide_labels {
        order_guide_name
        level
      }
    }
    variant_pack {
      external_item_id
      pack {
        base_unit
        unit
        max_unit_size
        min_unit_size
        uuid
      }
      uuid
    }
    request_notes {
      collection_id
      persist_request
      request
    }
    variant_pack_id
    variant_pack_info {
      currency
      max_quantity
      min_quantity
      on_hand_quantity
      gross_profit_in_percentage
      gross_profit_amount_display
      pack_cost_in_micros
      pack_price_in_micros
      pack_price_display
      default_pack_price_in_micros
      default_unit_price_in_micros
      unit_cost_in_micros
      unit_count
      unit_price_in_micros
      unit_price_display
      price_edit_info {
        active_override
        expires_at
        expiration_source
        ceiling_price_in_micros
        cost_info {
          details {
            cost_in_micros
            type
          }
        }
        gross_profit_override_in_percentage
        price_edited_by_user_name
        price_override_in_micros
        variant_pack_settings {
          disable_override_editing
          disable_sales_rep_info
          enable_peak_price_protection
        }
      }
    }
  }
`;
